import {createSlice} from "@reduxjs/toolkit";
import {getRol, addRol, updateRol, deleteRol} from "./thunks";


export const initialState: any = {
    rolLists: [],
    error: {},
    isLoading: false,
};


const RolSlice = createSlice({
    name: 'RolSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        //Get Rol
        builder.addCase(getRol.pending, (state: any) => {
            state.isLoading = true;
        });
        builder.addCase(getRol.fulfilled, (state: any, action: any) => {
            state.isLoading = false;
            state.rolLists = action.payload.data ? action.payload.data : action.payload;
        });
        builder.addCase(getRol.rejected, (state: any, action: any) => {
            state.isLoading = false;
            state.error = action.payload?.error || action.payload || null;
        });

        //Add Rol
        builder.addCase(addRol.pending, (state: any) => {
            state.isLoading = true;
        });
        builder.addCase(addRol.fulfilled, (state: any, action: any) => {
            state.isLoading = false;
            state.rolLists = [...state.rolLists, action.payload.data ? action.payload.data : action.payload];
        });
        builder.addCase(addRol.rejected, (state: any, action: any) => {
            state.isLoading = false;
            state.error = action.payload?.error || action.payload || null;
        });
        
        //UpdateRol
        builder.addCase(updateRol.pending, (state: any) => {
            state.isLoading = true;
        });
        builder.addCase(updateRol.fulfilled, (state: any, action: any) => {
            state.isLoading = false;
            state.rolLists = state.rolLists.map((rol: any) =>
                rol.id === action.meta.arg.id
                    ? {...rol, ...action.meta.arg}
                    : rol
            );
        });
        builder.addCase(updateRol.rejected, (state: any, action: any) => {
            state.isLoading = false;
            state.error = action.payload?.error || action.payload || null;
        });

        //Delete Rol
        builder.addCase(deleteRol.pending, (state: any) => {
            state.isLoading = true;
        });
        builder.addCase(deleteRol.fulfilled, (state: any, action: any) => {
            state.isLoading = false;
            state.rolLists = (state.rolLists || []).filter((product: any) => product.id !== action.payload.id);
        });
        builder.addCase(deleteRol.rejected, (state: any, action: any) => {
            state.isLoading = false;
            state.error = action.payload?.error || action.payload || null;
        });

    }
});

export default RolSlice.reducer;
